export default "__VITE_ASSET__BGv1DyPy__"